import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserInfo } from 'hooks/useUserInfo';
import { Box, Typography } from '@mui/material';

interface RiskToolsRouteProps {
  children: React.ReactNode;
  fallbackPath?: string;
  showAccessDenied?: boolean;
}

// Route guard for the Risk-team tools: allows administrators and users with the RiskAnalysts
// role. Mirrors AdminRoute (signed-in roles, not affected by impersonation).
const RiskToolsRoute: React.FC<RiskToolsRouteProps> = ({ children, fallbackPath = '/', showAccessDenied = false }) => {
  const { isAdmin, isRiskAnalyst } = useUserInfo();

  if (!isAdmin && !isRiskAnalyst) {
    if (showAccessDenied) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px" flexDirection="column" gap={2}>
          <Typography variant="h5" color="error">
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary">
            You do not have the required privileges to access this page.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This page is available to administrators and the Risk team.
          </Typography>
        </Box>
      );
    }
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default RiskToolsRoute;
